export const missing = (length: number) =>
  ({
    text: ' '.repeat(length),
    meta: { underline: true },
  } as const);
